// extracted by mini-css-extract-plugin
export var bodySections = "_b1-8";
export var gray = "_b1-7";
export var green = "_b1-4";
export var iconContainer = "_b1-9";
export var iconWidgetContainer = "_b1-1";
export var phoneIcon = "_b1-2";
export var red = "_b1-5";
export var statusDot = "_b1-3";
export var widgetContainer = "_b1-0";
export var yellow = "_b1-6";